import { observer } from 'mobx-react-lite';

import { Table } from '@/components/table';

import { farmerPlotsStore } from '@/stores';
import { getColumns } from './setup';

export const Plots = observer(({ farmerId, farmer }: any) => {
  const items = farmerPlotsStore.items;

  const columns = getColumns(farmerId);

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={[...items]}
      store={farmerPlotsStore}
      loading={farmerPlotsStore.loading}
      scroll={{ x: 950 }}
      relId={farmerId}
    />
  );
});
